import { mapActions, mapState } from 'vuex';
import { isBlank } from 'utils/string';

export const billingEnumMixins = {
  computed: {
    ...mapState({
      billingInvoiceEmailSentProgress: (state) =>
        state['enum'].billingEnum.billingInvoiceEmailSentProgress,
      hyperTapEntityList: (state) => state['enum'].billingEnum.hyperTapEntityList,
      affBillingAppStatusList: (state) => state['enum'].billingEnum.affBillingAppStatusList,
      reconciliationProgressList: (state) => state['enum'].billingEnum.reconciliationProgressList,

      affPaymentMergeStatusList: (state) => state['enum'].billingEnum.affPaymentMergeStatusList,
      affFullPaymentStatusList: (state) => state['enum'].billingEnum.affFullPaymentStatusList,
      affHedgeAppPaymentStatusList: (state) =>
        state['enum'].billingEnum.affHedgeAppPaymentStatusList,
      affHedgeAppAuditStatusList: (state) => state['enum'].billingEnum.affHedgeAppAuditStatusList,
      currencyList: (state) => state['enum'].billingEnum.currencyList,
      affPaymentAppAuditStatusList: (state) =>
        state['enum'].billingEnum.affPaymentAppAuditStatusList,
      affPrePaidPaymentAppPaymentStatusList: (state) =>
        state['enum'].billingEnum.affPrePaidPaymentAppPaymentStatusList,
      affPaymentAppFinancePaymentStatusList: (state) =>
        state['enum'].billingEnum.affPaymentAppFinancePaymentStatusList,
      affPaymentAppOperationPaymentStatusList: (state) =>
        state['enum'].billingEnum.affPaymentAppOperationPaymentStatusList,
      affPaymentTypeList: (state) => state['enum'].billingEnum.affPaymentTypeList,

      advInvoiceAppAuditStatusList: (state) =>
        state['enum'].billingEnum.advInvoiceAppAuditStatusList,
      advFullReceiptStatusList: (state) => state['enum'].billingEnum.advFullReceiptStatusList,
      advHedgeAppReceiptStatusList: (state) =>
        state['enum'].billingEnum.advHedgeAppReceiptStatusList,
      advHedgeAppAuditStatusList: (state) => state['enum'].billingEnum.advHedgeAppAuditStatusList,
      advReceiptClaimStatusList: (state) => state['enum'].billingEnum.advReceiptClaimStatusList,
      advReceiptClaimCurrencyList: (state) => state['enum'].billingEnum.advReceiptClaimCurrencyList,
      advReceiptClaimReceiptTypeList: (state) =>
        state['enum'].billingEnum.advReceiptClaimReceiptTypeList,
      advReceiptClaimReceiptStatusList: (state) =>
        state['enum'].billingEnum.advReceiptClaimReceiptStatusList,
    }),
  },
  created() {
    this.getBillingEnum();
  },
  methods: {
    ...mapActions({
      getBillingEnum: 'enum/getBillingEnum',
    }),
    getEnumLabel(enums, value) {
      return enums.find((item) => item && item.value === value)?.label || '';
    },
    /*getHyperTapEntity(value) {
      if (isBlank(value)) {
        return '';
      }
      return this.hyperTapEntityList.find((item) => item.value === value)?.label || '';
    },*/
    getPaymentType(value) {
      if (isBlank(value)) {
        return '';
      }
      return this.getEnumLabel(this.affPaymentTypeList, value);
    },
    getPaymentStatus(value) {
      if (isBlank(value)) {
        return '';
      }
      return this.affHedgeAppPaymentStatusList.find((item) => item.value === value)?.label || '';
    },
    getPaymentAppAuditStatus(value) {
      if (isBlank(value)) {
        return '';
      }
      return this.affPaymentAppAuditStatusList.find((item) => item.value === value)?.label || '';
    },
    getAffPaymentAppPaymentStatus(value) {
      if (isBlank(value)) {
        return '';
      }
      return (
        this.affPaymentAppFinancePaymentStatusList.find((item) => item.value === value)?.label || ''
      );
    },
    getApplicationAuditStatus(value) {
      if (isBlank(value)) {
        return '';
      }
      return this.affHedgeAppAuditStatusList.find((item) => item.value === value)?.label || '';
    },
  },
};
